import { PAYMENT_METHODS } from '../../constants';

export const getDefaultPaymentMethodType = (
	availablePaymentMethods = {},
	preferredPaymentMethodType,
) => {
	if (preferredPaymentMethodType && availablePaymentMethods[preferredPaymentMethodType]) {
		return preferredPaymentMethodType;
	}
	if (availablePaymentMethods.suPaymentMethods) {
		return PAYMENT_METHODS.suPaymentMethods;
	}
	if (availablePaymentMethods.suBusinessAccount) {
		return PAYMENT_METHODS.suBusinessAccount;
	}
	if (availablePaymentMethods.suPayout) {
		return PAYMENT_METHODS.suPayout;
	}
	return PAYMENT_METHODS.creditCard;
};
